// Accountant dashboard
import React, { useCallback, useState } from 'react';
import View from 'src/pages/accountants/overview';
import AppRender from 'src/routes/app-render';
import { fuelsApi } from 'src/api/fuels/vm-view';
import { repairApi } from 'src/api/repairs/vm-view';

const Page = () => {

  const [data, setData] = useState({});
  const [isLoaded, setIsLoaded] = useState({ fuels: false, repairs: false });

  const fetchData = useCallback(async () => {
    fuelsApi.getSummary((result) => {
        setData((prev) => ({ ...prev, fuels: result }));
        setIsLoaded((prev) => ({ ...prev, fuels: true }));
      }
    );
    repairApi.getSummary((result) => {
        setData((prev) => ({ ...prev, repairs: result }));
        setIsLoaded((prev) => ({ ...prev, repairs: true }));
      }
    );
  }, []); 

  const allLoaded = isLoaded.fuels && isLoaded.repairs;
  return (
    <AppRender apiCall={fetchData}>
      {allLoaded && (<View fuels={data.fuels} repairs={data.repairs} />)}
    </AppRender>
  );
};

export default Page;
